<ng-container *ngIf="isDataExist; then showPersons else emptyPersonsTable"></ng-container>

<ng-template #showPersons>
  <greydom-hint></greydom-hint>

  <div class="mat-elevation-z8 table-container">
    <table [dataSource]="dataSource"
           mat-table matSort
           multiTemplateDataRows>

      <ng-container [matColumnDef]="tableColumns.DependentNumber">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Dep No</th>
        <td *matCellDef="let row" mat-cell>{{row.dependentNumber}}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.IdentificationType">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>ID Type</th>
        <td *matCellDef="let row" mat-cell>{{row.identification?.idTypeCode}}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.IdentificationNumber">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>ID Number</th>
        <td *matCellDef="let row" mat-cell>{{row.identification?.idNumber}}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.FullName">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Full Name</th>
        <td *matCellDef="let row" mat-cell>{{getFullName(row)}}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.AssociationCode">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Association</th>
        <td *matCellDef="let row" mat-cell>{{row.associationCode}}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.RelationshipTypeCode">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Relationship</th>
        <td *matCellDef="let row" mat-cell>{{row.relationshipTypeCode}}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.Gender">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Gender</th>
        <td *matCellDef="let row" mat-cell>{{row.gender}}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.DateOfBirth">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Date of Birth</th>
        <td *matCellDef="let row" mat-cell>{{row.dateOfBirth | date: dateFormat}}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.isVerified">
        <th *matHeaderCellDef mat-header-cell mat-sort-header> Is ID Verified</th>
        <td *matCellDef="let row" mat-cell>
          <ng-container
            *ngTemplateOutlet="indicatorAndStatusTpl; context: { $implicit: row, field: tableColumns.isVerified }"></ng-container>
        </td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.isAlive">
        <th *matHeaderCellDef mat-header-cell mat-sort-header> Is Alive</th>
        <td *matCellDef="let row" mat-cell>
          <ng-container
            *ngTemplateOutlet="indicatorAndStatusTpl; context: { $implicit: row, field: tableColumns.isAlive }"></ng-container>
        </td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.GeneralWaitingPeriod">
        <th *matHeaderCellDef mat-header-cell>General Waiting Period</th>
        <td *matCellDef="let row" mat-cell>
          <ng-container *ngTemplateOutlet="waitingPeriodTemplate; context: { $implicit: row, field: waitingPeriodType.General, editDisabled: !hasOnboardingRole}"></ng-container>
          <mat-slide-toggle
            [disabled]="!hasOnboardingRole"
            [checked]="row.generalWaitingPeriodIncPMBIndicator"
            (change)="onGeneralWaitingPeriodInclPMBToggleChange($event, row.applicationPersonId)"
            (click)="$event.stopPropagation()">
            {{row.generalWaitingPeriodIncPMBIndicator ? 'No PMB' : 'PMB Allowed'}}
          </mat-slide-toggle>
        </td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.PECWaitingPeriod">
        <th *matHeaderCellDef mat-header-cell>PEC Waiting Period</th>
        <td *matCellDef="let row" mat-cell>
          <ng-container *ngTemplateOutlet="waitingPeriodTemplate; context: { $implicit: row, field: waitingPeriodType.PEC, editDisabled: !hasOnboardingRole}"></ng-container>
          <mat-slide-toggle
            [disabled]="!hasOnboardingRole"
            [checked]="row.pecWaitingPeriodIncPMBIndicator"
            (change)="onPecWaitingPeriodInclPMBToggleChange($event, row.applicationPersonId)"
            (click)="$event.stopPropagation()">
            {{row.pecWaitingPeriodIncPMBIndicator ? 'No PMB' : 'PMB Allowed'}}
          </mat-slide-toggle>
        </td>
      </ng-container>

      <!-- Expanded Content Column -->
      <ng-container matColumnDef="expandedDetail">
        <td *matCellDef="let row" [attr.colspan]="displayedColumns.length" mat-cell>
          <div [@detailExpand]="row == expandedElement ? 'expanded' : 'collapsed'"
               class="row-detail-container">
            <br/>
            <b>Existing Member:</b> {{row.isExistingIndicator}}<br/>
            <b>Title:</b> {{row.title}}<br/>
            <b>Language:</b> {{row.language}}<br/>
            <b>Ethnicity:</b> {{row.ethnicity}}<br/>
            <b>Marital Status:</b> {{row.maritalStatus}}<br/>
            <b>Date of Marriage:</b> {{row.dateOfMarriage | date:dateFormat}}<br/>
            <b>Adoption Date:</b> {{row.adoptionDate | date:dateFormat}}<br/>
            <b>Receive Hard Copy Card:</b> {{row.receiveHardCopyCard ? 'Yes' : 'No'}}<br/>
            <b>Override General Waiting
              Period:</b> {{row.overrideGeneralWaitingPeriod ? 'Yes' : 'No'}}<br/>
            <b>Override Pre-existing Condition Waiting
              Period:</b> {{row.overridePreExistingConditionWaitingPeriod ? 'Yes' : 'No'}}<br/>

            <app-person-contacts 
              [contacts]="row.contacts" 
              [applicationPersonId]="row.applicationPersonId"
              [isApplicationLocked]="isApplicationLocked"
              (contactsUpdated)="handleContactDetailsUpdate($event)">
            </app-person-contacts>
            
            <app-person-conditions [conditions]="row.conditions"
                                   [diagnosisGroups]="diagnosisGroups"
                                   [isApplicationLocked]="isApplicationLocked"
                                   (conditionsChange)="handleConditionChange($event, row.applicationPersonId)">
            </app-person-conditions>
            
            <app-person-scheme-history
              [schemeHistory]="row.schemeHistory"
              [applicationPersonId]="row.applicationPersonId"
              [isApplicationLocked]="isApplicationLocked"
              (schemeHistoryUpdated)="handleSchemeHistoryUpdate($event)">
            </app-person-scheme-history>
            
            <app-person-employment-details
              [employmentDetails]="row.employmentDetails"
              [applicationPersonId]="row.applicationPersonId"
              [isApplicationLocked]="isApplicationLocked"
              (employmentUpdated)="handleEmploymentUpdate($event)">
            </app-person-employment-details>
          </div>
        </td>
      </ng-container>

      <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
      <tr (click)="expandedElement = expandedElement === element ? null : element"
          *matRowDef="let element; columns: displayedColumns;"
          [class.expanded-row]="expandedElement === element"
          class="element-row"
          mat-row>
      </tr>
      <tr *matRowDef="let row; columns: ['expandedDetail']" class="detail-row" mat-row></tr>
    </table>

    <mat-paginator [length]="tableControl.length"
                   [pageSize]="tableControl.pageSize"
                   [pageSizeOptions]="tableControl.pageSizeOptions"
                   (page)="pageChanged($event)">
    </mat-paginator>
  </div>
</ng-template>


<!---------------------------->
<!-- General/PEC Waiting Period Tpl:-->
<!---------------------------->
<ng-template #waitingPeriodTemplate let-row let-field="field" let-editDisabled="editDisabled">
  <ng-container *ngIf="!row.editState[field].isEditing; else editingWaitingPeriod">
    <b>{{row[field]}}</b>
      <mat-icon *ngIf="!editDisabled" (click)="toggleEdit($event, row, field)" class="edit-icon table-icon">edit</mat-icon>
  </ng-container>
  <ng-template #editingWaitingPeriod>
    <mat-form-field class="w-45">
      <input [(ngModel)]="row.editState[field].tempValue" matInput type="number">
    </mat-form-field>
    <mat-icon (click)="toggleEdit($event, row, field)" class="cancel-icon" matTooltip="Cancel edit" style="color: grey;">cancel</mat-icon>
    <mat-icon (click)="saveWaitingPeriod($event, row, field)" class="table-icon save-icon" matTooltip="Save number">save</mat-icon>
  </ng-template>
</ng-template>

<ng-template #indicatorAndStatusTpl let-row let-field="field">
  <div class="flex justify-start">
    <greydom-status-indicator
      [fillColor]="getStatusColor(row?.identification[field])"></greydom-status-indicator>
    <span class="m-l-5">{{getVerificationStatus(row?.identification[field])}}</span>
  </div>
</ng-template>

<!-- Empty Table Tpl:-->
<ng-template #emptyPersonsTable>
  <div class="text-center">
    <label class="column-label">No persons</label>
  </div>
</ng-template>
